import { connect } from 'react-redux';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import { ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import { Forms } from '../..';
import Security from '../../../services/seguridad';
import { Roles } from '../../../services/api/seguridad/model/IRol';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function CardSeccionFacturacion({ storage, t,
  data,
  onUpdateFields
} : IProps) {
  const onUpdateField = (field: string, value: any) => onUpdateFields([ { field, value }]);

  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Facturacion}`)}</div>
    
    <div className='p-grid'>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Input 
          title={t("Seccion.Field.operacionfacturacion.facturaNumero")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.facturanumero}
          onChange={(v,e) => onUpdateField('operacionfacturacion.facturanumero', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.operacionfacturacion.facturaFecha")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.facturafecha ? new Date(data?.operacionfacturacion?.facturafecha) : undefined}
          onChange={(v,e) => onUpdateField('operacionfacturacion.facturaFecha', v)}
        />
      </div>
      <div className='p-col-12 p-lg-12 p-p-2'>
        <Forms.UploadSingleFile 
          title={t("Seccion.Field.operacionfacturacion.facturaArchivo")}
          className={styles["fix-form-component"]}
          hideDelete
          value={data?.operacionfacturacion?.facturaArchivoDTO}
          onChange={(v,e) => onUpdateField('operacionfacturacion.facturaArchivoDTO', v)}
        />
      </div>
      
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Input 
          title={t("Seccion.Field.operacion.factura_tipo")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.paxfacturatipo}
          disabled={!Security.HasOneRolOf([Roles.Admin, Roles.AdministradorMarca, Roles.Operador, Roles.Supervisor, Roles.EjecutivoCuenta ])}
          onChange={(v,e) => onUpdateField('operacionfacturacion.paxfacturatipo', v)}
        />
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Input 
          title={t("Seccion.Field.operacion.factura_razonsocial")}
          className={styles["fix-form-component"]}
          disabled={!Security.HasOneRolOf([Roles.Admin, Roles.AdministradorMarca, Roles.Operador, Roles.Supervisor, Roles.EjecutivoCuenta ])}
          value={data?.operacionfacturacion?.paxrazonsocial}
          onChange={(v,e) => onUpdateField('operacionfacturacion.paxrazonsocial', v)}
        />
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Input 
          title={t("Seccion.Field.operacion.factura_documento")}
          className={styles["fix-form-component"]}
          disabled={!Security.HasOneRolOf([Roles.Admin, Roles.AdministradorMarca, Roles.Operador, Roles.Supervisor, Roles.EjecutivoCuenta ])}
          value={data?.operacionfacturacion?.paxdocumento}
          onChange={(v,e) => onUpdateField('operacionfacturacion.paxdocumento', v)}
        />
      </div>

    </div>
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionFacturacion);
